const isNumber = (data) => {
  let value = data.value;
  if (value === null || value === undefined) return "must be all numbers"
  value = value.trim();
  return (!isNaN(value)) ? true : "must be all numbers";
}

export default isNumber;
